import filterModule from "./filterModule.js";
import manifestHeaderModule from "./manifestHeaderModule.js";

export default {
  namespaced: true,
  modules: {
    filterModule,
    manifestHeaderModule
  }
};
